import { useCallback, useState, useRef } from 'react';

import { UserProfileButtonBase } from './UserProfileButtonBase';
import { UserProfileMenu } from './UserProfileMenu';

interface UserProfileButtonProps {
  /**
   * User data
   */
  user: {
    name: string;
    avatar?: string;
  };

  /**
   * Callback when the sign out button is clicked
   */
  onSignOut?: () => void;

  /**
   * Additional CSS class name
   */
  className?: string;
}

/**
 * UserProfileButton component that wraps the design system's UserProfileButtonBase
 * and uses the new Menu component for the dropdown
 */
export function UserProfileButton({ user, onSignOut, className }: UserProfileButtonProps) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const buttonId = 'user-profile-button';
  const containerRef = useRef<HTMLDivElement>(null);

  // Handle button click
  const handleClick = useCallback(() => {
    setIsMenuOpen(prev => !prev);
  }, []);

  // Handle close menu
  const handleCloseMenu = useCallback(() => {
    setIsMenuOpen(false);
  }, []);

  return (
    <div ref={containerRef} style={{ position: 'relative' }}>
      <UserProfileButtonBase className={className} id={buttonId} user={user} onClick={handleClick} />
      <UserProfileMenu isOpen={isMenuOpen} triggerId={buttonId} user={user} onClose={handleCloseMenu} onSignOut={onSignOut} />
    </div>
  );
}
